<template>
  <div class="switch__header switch__header--single">
    <img class="switch__icon" src="@/assets/icons/ico_lock-accent.svg" alt="">
    <div class="switch__text">
      <h2 class="switch__title">{{ $t(`${namespace}.title`) }}</h2>
      <p class="switch__subtitle">
        {{ allowWebcall ? $t(`${namespace}.subtitleEnabled`) : $t(`${namespace}.subtitleDisabled`) }}
      </p>
    </div>

    <v-switch
      v-model="allowWebcall"
      color="success"
      hide-details
      @change="handleAllowWebCall"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AllowWebCallSwitch',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    companyId () {
      const { id } = this.$route.params
      return Number(id) || null
    }
  },
  data () {
    return {
      namespace: 'Components.AllowWebCallSwitch',
      allowWebcall: false,
      defaultStatus: false
    }
  },
  watch: {
    data: {
      deep: true,
      handler (val) {
        const { allowWebcall } = val || {}
        this.allowWebcall = allowWebcall
        this.defaultStatus = allowWebcall
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    async handleAllowWebCall () {
      try {
        const { allowWebcall } = this

        await this.$apiService.setCompanyAllowWebCall(
          this.companyId,
          { enabled: allowWebcall }
        )

        this.$emit('update', { allowWebcall })

        this.allowWebcall
          ? this.showAlert({ type: 'success', message: this.$t(`${this.namespace}.successEnabled`) })
          : this.showAlert({ type: 'success', message: this.$t(`${this.namespace}.successDisabled`) })
      } catch (err) {
        console.log('ERROR:', err)
        this.allowWebcall = this.defaultStatus
        this.showAlert({ type: 'error', message: this.$t(`${this.namespace}.error`) })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.switch__header {
  color: $gray-7;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  padding: 18px 24px;
  position: relative;

  .switch__icon {
    left: 16px;
    margin-right: 10px;
    padding: 0 2px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
  }

  .switch__text {
    padding-left: 31px;
    padding-right: 45px;
  }

  .switch__title {
    font-size: 18px;
    font-weight: 800;
  }

  .switch__subtitle {
    color: $gray-6;
    font-family: "Work Sans", sans-serif;
    margin-bottom: 0;
    font-size: 12px;
    font-weight: normal;
    text-transform: none;
  }
}
</style>

<style lang="scss">
.switch__header--single {

  .v-input--switch  {
    margin: 0;
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
